/**
 * the language property keys to all browsers
 */
const browserLanguagePropertyKeys = [
  'language',
  'browserLanguage',
  'systemLanguage',
  'userLanguage',
]

/**
 * Get the first browser language from navigator.
 * default to 'zh-CN'
 *
 * @returns {String} browser language
 */
export function getFirstBrowserLanguage(): string {
  let fallbackLanguage = 'zh-CN'

  const checkLanguage = (language = '') => {
    const len = language.length

    if (len >= 2) {
      if (!fallbackLanguage) {
        fallbackLanguage = language.replace('_', '-')
      }

      return len > 2
    }

    return false
  }

  // support for HTML 5.1 "navigator.languages"
  if (Array.isArray(navigator.languages)) {
    for (const language of navigator.languages) {
      if (checkLanguage(language)) {
        return language.replace('_', '-')
      }
    }
  }

  // support for other well known properties in browsers
  for (const key of browserLanguagePropertyKeys) {
    const language = (navigator as any)[key] as string

    if (checkLanguage(language)) {
      return language.replace('_', '-')
    }
  }

  return fallbackLanguage
}

/**
 * Get the 2 length of short language from navigator.
 *
 * @returns {String} short language
 */
export function getShortLanguage(): string {
  return getFirstBrowserLanguage().split('-')[0]
}
